import { useMemo } from "react";
import { Env } from "utils/Types";
import { useAppSelector } from "redux/hooks";
import { WHITELABEL } from "utils/Constants";
import { isValidEnv } from "redux/reducers/GlobalUiSlice";

const useOpenDateConfigs = () => {
  const { isSrsOpen, isSrsOpenOS } = useAppSelector(state => state.properties.closingData);
  const { env } = useAppSelector(state => state.globalUI);
  const whitelabel = useAppSelector(state => state.properties.whiteLabel);

  const srsOpen = useMemo(() => {
    if (whitelabel === WHITELABEL.utas) {
      return isSrsOpen;
    }
    if (!isValidEnv(env)) {
      return false;
    }
    const isOS = env === Env.INTERNATIONAL;
    const srsOpen = isOS ? isSrsOpenOS : isSrsOpen;
    return srsOpen;
  }, [env, isSrsOpenOS, isSrsOpenOS, whitelabel]);

  return { srsOpen };
};

export default useOpenDateConfigs;
